import { render, staticRenderFns } from "./DuvalView.vue?vue&type=template&id=10b7a91d&scoped=true&"
import script from "./DuvalView.vue?vue&type=script&lang=js&"
export * from "./DuvalView.vue?vue&type=script&lang=js&"
import style0 from "./DuvalView.vue?vue&type=style&index=0&id=10b7a91d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b7a91d",
  null
  
)

export default component.exports